module.exports = __webpack_public_path__ + "media/images/shared/about_live/say/2-3f105d8bf3b2dda6a413a5b4a0484ced.png";